import { SELECT_YOUR_X_INDEX_CHANGED } from './actionTypes';

export const dropdownIndex = {
    brand: 0,
    device: 1,
    model: 2
};

export function selectYourXIndexChanged(dropdownIndex) {
    return { type: SELECT_YOUR_X_INDEX_CHANGED, dropdownIndex };
}